import Vue from 'vue'
import Router from 'vue-router'
import login from '@/pages/login'

import menu from '@/pages/menu'
import menu_master from '@/pages/menu_master'
import menu_maintenance from '@/pages/menu_maintenance'
import menu_configuration from '@/pages/menu_configuration'
import menu_certificate from '@/pages/menu_certificate'
import menu_inventory from '@/pages/menu_inventory'

import company from '@/pages/company'

import page_0001_reset_password from '@/pages/page_0001_reset_password'
import page_0002_login_expired from '@/pages/page_0002_login_expired'
import page_0010_device_embedded_information from '@/pages/page_0010_device_embedded_information'
import page_0010_device_embedded_information_detail from '@/pages/page_0010_device_embedded_information_detail'
import page_0010_device_embedded_information_detail_bulk_edit from '@/pages/page_0010_device_embedded_information_detail_bulk_edit'

import page_0015_device_embedded_information_pegging from '@/pages/page_0015_device_embedded_information_pegging'
import page_0016_device_embedded_information_pegging2 from '@/pages/page_0016_device_embedded_information_pegging2'
import page_0030_bulk_import from '@/pages/page_0030_bulk_import'
import page_0020_surplus_license from '@/pages/page_0020_surplus_license'
import page_0020_surplus_license_detail from '@/pages/page_0020_surplus_license_detail'
import page_0020_surplus_license_request from '@/pages/page_0020_surplus_license_request'

import page_0040_certificate_software from '@/pages/page_0040_certificate_software'
import page_0040_certificate_software_detail from '@/pages/page_0040_certificate_software_detail'
import page_0040_certificate_software_detail_bulk_edit from '@/pages/page_0040_certificate_software_detail_bulk_edit'
import page_0040_certificate_software_linked_devices from '@/pages/page_0040_certificate_software_linked_devices'
import page_0040_certificate_software_linked_devices_select from '@/pages/page_0040_certificate_software_linked_devices_select'

import page_0040_certificate_information from '@/pages/page_0040_certificate_information'
import page_0040_certificate_information_detail from '@/pages/page_0040_certificate_information_detail'
import page_0040_certificate_information_pegging from '@/pages/page_0040_certificate_information_pegging'
import page_0040_certificate_information_pegging_choice from '@/pages/page_0040_certificate_information_pegging_choice'
import page_0040_certificate_information_detail_bulk_edit from '@/pages/page_0040_certificate_information_detail_bulk_edit'
import page_0040_certificate_information_linked_devices from '@/pages/page_0040_certificate_information_linked_devices'
import page_0040_certificate_information_linked_devices_select from '@/pages/page_0040_certificate_information_linked_devices_select'
import page_0040_notification_certificate from '@/pages/page_0040_notification_certificate'
// import page_0040_notification_certificate_over from '@/pages/page_0040_notification_certificate_over'

import page_0041_master_user from '@/pages/page_0041_master_user'
import page_0041_master_user_detail from '@/pages/page_0041_master_user_detail'
import page_0041_master_user_detail_bulk_edit from '@/pages/page_0041_master_user_detail_bulk_edit'

import page_0041_master_belongs_detail from '@/pages/page_0041_master_belongs_detail'
import page_0041_master_belongs from '@/pages/page_0041_master_belongs'

import page_0041_master_software_category_detail from '@/pages/page_0041_master_software_category_detail'
import page_0041_master_software_category from '@/pages/page_0041_master_software_category'

import page_0041_master_company_detail from '@/pages/page_0041_master_company_detail'
import page_0041_master_company from '@/pages/page_0041_master_company'

import page_0041_master_comprehensive_contract_detail from '@/pages/page_0041_master_comprehensive_contract_detail'
import page_0041_master_comprehensive_contract from '@/pages/page_0041_master_comprehensive_contract'

import page_0041_master_software_detail from '@/pages/page_0041_master_software_detail'
import page_0041_master_software from '@/pages/page_0041_master_software'
import page_0041_master_system_detail from '@/pages/page_0041_master_system_detail'
import page_0041_master_system from '@/pages/page_0041_master_system'
import page_0041_master_maker from '@/pages/page_0041_master_maker'
import page_0041_master_maker_detail from '@/pages/page_0041_master_maker_detail'
import page_0041_master_inventory_reporting_period from '@/pages/page_0041_master_inventory_reporting_period'
import page_0041_master_inventory_reporting_period_detail from '@/pages/page_0041_master_inventory_reporting_period_detail'

import page_0041_master_change_password from '@/pages/page_0041_master_change_password'
import first_time_change_password from '@/pages/first_time_change_password'

// import page_0050_approval_history from '@/pages/page_0050_approval_history'

import page_0050_approval_history_tabs from '@/pages/page_0050_approval_history_tabs'
import page_0050_approval_history_detail from '@/pages/page_0050_approval_history_detail'

import page_0050_id_approval_history from '@/pages/page_0050_id_approval_history'
import page_0051_approval_history_device_embedded_information_detail from '@/pages/page_0051_approval_history_device_embedded_information_detail'

// import page_0052_pw_approval_history from '@/pages/page_0052_pw_approval_history'
// import page_0052_pw_approval_history_detail from '@/pages/page_0052_pw_approval_history_detail'

import page_0060_redirect from '@/pages/page_0060_redirect'

// import page_0070_inventory_copy from '@/pages/page_0070_inventory_copy'
import page_0071_inventory_report from '@/pages/page_0071_inventory_report'
import page_0072_inventory_report_check from '@/pages/page_0072_inventory_report_check'
import page_0070_inventory_tabs from '@/pages/page_0070_inventory_tabs'

import page_0073_excess_deficiency_summary from '@/pages/page_0073_excess_deficiency_summary'

import page_0080_system_setting_detail from '@/pages/page_0080_system_setting_detail'
import page_0080_browser_setting_detail from '@/pages/page_0080_browser_setting_detail'

import page_0081_mail_message from '@/pages/page_0081_mail_message'
import page_0081_mail_message_detail from '@/pages/page_0081_mail_message_detail'
import page_0081_mail_message_create from '@/pages/page_0081_mail_message_create'
import page_0081_mail_message_users from '@/pages/page_0081_mail_message_users'

import page_0090_notice from '@/pages/page_0090_notice'
import page_0090_notice_detail from '@/pages/page_0090_notice_detail'

import page_0090_deposit_certificate_output from '@/pages/page_0090_deposit_certificate_output'

import page_0091_programs_and_permissions from '@/pages/page_0091_programs_and_permissions'
import page_0091_programs_and_permissions_detail from '@/pages/page_0091_programs_and_permissions_detail'

import page_0092_reload from '@/pages/page_0092_reload'

import page_0093_old_bulk_import from '@/pages/page_0093_old_bulk_import'

// import Page2 from '@/pages/OldPage2'
// import Page4 from '@/pages/OldPage4'

// import PageTemp from '@/pages/PageTemp'

Vue.use(Router)
//https://github.com/vuejs/vuex-router-sync if need to access store
var router = new Router({
  routes: [{
      path: '/',
      name: 'login',
      component: login,
      meta: {
        requiresAuth: false,
        isLogin:true
      }
    }, {
      path: '/logout',
      name: 'Logout',
      component: login,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/logout/duo',
      name: 'LogoutDuo',
      component: login,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/expired',
      name: 'page_0002_login_expired',
      component: page_0002_login_expired,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/reset_password',
      name: 'ResetPassword',
      component: page_0001_reset_password,
      meta: {
        requiresAuth: false,
        // isResetPassword:true
      }
    },
    {
      path: '/company',
      name: 'Company',
      component: company,
      meta: {
        requiresAuth: true,
        isPreLogin:true
      }
    },
    {
      path: '/change_password/expired',
      name: 'first_time_change_password_expired',
      component: first_time_change_password,
      meta: {
        requiresAuth: true,
        isPreLogin:true,
        password_expired:true
      }
    },
    {
      path: '/change_password',
      name: 'first_time_change_password',
      component: first_time_change_password,
      meta: {
        requiresAuth: true,
        isPreLogin:true
      }
    },
    {
      path: '/redirect',
      name: 'page_0060_redirect',
      component: page_0060_redirect,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/inventory',
      name: 'page_0070_inventory_tabs',
      component: page_0070_inventory_tabs,
      meta: {
        requiresAuth: true,
        tab:"inventory_management",
        tab_index:0
      }
    },
    {
      path: '/inventory_management',
      name: 'page_0070_inventory_tabs_management',
      component: page_0070_inventory_tabs,
      meta: {
        requiresAuth: true,
        tab:"inventory_management",
        tab_index:0
      }
    },
    {
      path: '/inventory_certificate_list',
      name: 'page_0070_inventory_tabs_certificate_list',
      component: page_0070_inventory_tabs,
      meta: {
        requiresAuth: true,
        tab:"inventory_certificate_list",
        tab_index:1
      }
    },
    {
      path: '/inventory_pending_items',
      name: 'page_0070_inventory_tabs_pending_items',
      component: page_0070_inventory_tabs,
      meta: {
        requiresAuth: true,
        tab:"inventory_pending_items",
        tab_index:2
      }
    },
  //   {
  //     path: '/inventory',
  //     name: 'page_0070_inventory_copy',
  //     component: page_0070_inventory_copy,
  //     meta: {
  //       requiresAuth: true
  //     }
  //   },
    {
      path: '/inventory_report',
      name: 'page_0071_inventory_report',
      component: page_0071_inventory_report,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/inventory_report_check',
      name: 'page_0072_inventory_report_check',
      component: page_0072_inventory_report_check,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/excess_deficiency_summary',
      name: 'page_0073_excess_deficiency_summary',
      component: page_0073_excess_deficiency_summary,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/device_embedded_information',
      name: 'page_0010_device_embedded_information',
      component: page_0010_device_embedded_information,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/device_embedded_information/tab/:mode',
      name: 'page_0010_device_embedded_information_tab',
      component: page_0010_device_embedded_information,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/device_embedded_information/clone/:seq_id',
      name: 'page_0010_device_embedded_information_detail_clone',
      component: page_0010_device_embedded_information_detail,
      meta: {
        load_by:"clone",
        requiresAuth: true
      }
    },
    {
      path: '/device_embedded_information/:seq_id',
      name: 'page_0010_device_embedded_information_detail',
      component: page_0010_device_embedded_information_detail,
      meta: {
        load_by:"seq_id",
        requiresAuth: true
      }
    },
    {
      path: '/device_embedded_information/bulk_edit/:p_id',
      name: 'page_0010_device_embedded_information_detail_bulk_edit',
      component: page_0010_device_embedded_information_detail_bulk_edit,
      meta: {
        load_by:"seq_id",
        requiresAuth: true
      }
    },
    {
      path: '/device_embedded_information/approval/:approval_id/:fk_id',
      name: 'page_0010_device_embedded_information_detail_fk_id',
      component: page_0010_device_embedded_information_detail,
      meta: {
        load_by:"fk_id",
        approval_mode:true,
        requiresAuth: true
      }
    },
    {
      path: '/device_embedded_information_pegging/:seq_id',
      name: 'page_0015_device_embedded_information_pegging',
      component: page_0015_device_embedded_information_pegging,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/device_embedded_information_pegging2',
      name: 'page_0016_device_embedded_information_pegging2',
      component: page_0016_device_embedded_information_pegging2,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/surplus_license',
      name: 'page_0020_surplus_license',
      component: page_0020_surplus_license,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/surplus_license/:seq_id',
      name: 'page_0020_surplus_license_detail',
      component: page_0020_surplus_license_detail,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/surplus_license/review/:seq_id/:review_seq_id',
      name: 'page_0020_surplus_license_detail_review',
      component: page_0020_surplus_license_detail,
      meta: {
        load_by:"review",
        requiresAuth: true
      }
    },
    {
      path: '/surplus_license_request',
      name: 'page_0020_surplus_license_request',
      component: page_0020_surplus_license_request,
      meta: {
        requiresAuth: true
      }
    },

    // {
    //   path: '/surplus_license_allocation',
    //   name: 'page_0021_surplus_license_allocation',
    //   component: page_0021_surplus_license_allocation,
    //   meta: {
    //     requiresAuth: true
    //   }
    // },
    {
      path: '/bulk_import',
      name: 'page_0030_bulk_import',
      component: page_0030_bulk_import,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/bulk_import/:page/:session_id',
      name: 'page_0030_bulk_import_by_id',
      component: page_0030_bulk_import,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/certificate/tab/:mode',
      name: 'page_0040_certificate_software_tab',
      component: page_0040_certificate_software ,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/certificate',
      name: 'page_0040_certificate_software',
      component: page_0040_certificate_software ,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/certificate/n/:certificate_software_number',
      name: 'page_0040_certificate_software_detail_number',
      component: page_0040_certificate_software_detail ,
      meta: {
        load_by:"certificate_software_number",
        requiresAuth: true
      }
    },
    {
      path: '/certificate/deposit/:seq_id',
      name: 'page_0040_certificate_software_detail_number_deposit',
      component: page_0040_certificate_software_detail ,
      meta: {
        load_by:"deposit_certificate_output",
        requiresAuth: true
      }
    },
    {
      path: '/certificate/:seq_id',
      name: 'page_0040_certificate_software_detail',
      component: page_0040_certificate_software_detail,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/certificate/clone/:seq_id',
      name: 'page_0040_certificate_software_detail_clone',
      component: page_0040_certificate_software_detail,
      meta: {
        load_by:"clone",
        requiresAuth: true
      }
    },
    {
      path: '/certificate/approval/:approval_id/:fk_id',
      name: 'page_0040_certificate_information_detail_fk_id',
      component: page_0040_certificate_software_detail ,
      meta: {
        load_by:"fk_id",
        requiresAuth: true
      }
    },
    {
      path: '/certificate_software_linked_devices/list/:req_certificate_software_seq_id',
      name: 'page_0040_certificate_software_linked_devices',
      component: page_0040_certificate_software_linked_devices ,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/certificate_software_linked_devices/select/:req_certificate_software_seq_id',
      name: 'page_0040_certificate_software_linked_devices_select',
      component: page_0040_certificate_software_linked_devices_select ,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/certificate/bulk_edit/:p_id',
      name: 'page_0040_certificate_software_detail_bulk_edit',
      component: page_0040_certificate_software_detail_bulk_edit,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/certificate_information',
      name: 'page_0040_certificate_information',
      component: page_0040_certificate_information ,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/certificate_information/clone/:seq_id',
      name: 'page_0040_certificate_information_detail_clone',
      component: page_0040_certificate_information_detail,
      meta: {
        load_by:"clone",
        requiresAuth: true
      }
    },
    {
      path: '/certificate_information/:seq_id',
      name: 'page_0040_certificate_information_detail',
      component: page_0040_certificate_information_detail ,
      meta: {
        load_by:"seq_id",
        requiresAuth: true
      }
    },
    {
      // link_from_device_embedded_information_to_certificate_information_number step2
      path: '/certificate_information_number/:certificate_information_number',
      name: 'page_0040_certificate_information_detail_by_number',
      component: page_0040_certificate_information_detail ,
      meta: {
        load_by:"certificate_information_number",
        requiresAuth: true
      }
    },
    {
      path: '/certificate_information/approval/:approval_id/:fk_id',
      name: 'page_0040_certificate_information_detail_fk_id',
      component: page_0040_certificate_information_detail ,
      meta: {
        load_by:"fk_id",
        requiresAuth: true
      }
    },
    {
      path: '/certificate_information_pegging',
      name: 'page_0040_certificate_information_pegging',
      component: page_0040_certificate_information_pegging ,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/certificate_information_pegging_choice',
      name: 'page_0040_certificate_information_pegging_choice',
      component: page_0040_certificate_information_pegging_choice ,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/certificate_information_linked_devices/list/:req_ad_seq_id/:cert_id',
      name: 'page_0040_certificate_information_linked_devices',
      component: page_0040_certificate_information_linked_devices ,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/certificate_information_linked_devices/select/:req_ad_seq_id/:cert_id',
      name: 'page_0040_certificate_information_linked_devices_select',
      component: page_0040_certificate_information_linked_devices_select ,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/certificate_information/bulk_edit/:p_id',
      name: 'page_0040_certificate_information_detail_bulk_edit',
      component: page_0040_certificate_information_detail_bulk_edit ,
      meta: {
        load_by:"seq_id",
        requiresAuth: true
      }
    },
    {
      path: '/notification_certificate/certificate_3_months',
      name: 'page_0040_notification_certificate1',
      component: page_0040_notification_certificate ,
      meta: {
        requiresAuth: true,
        mode:"certificate_that_expires_in_3_months"
      }
    },
    {
      path: '/notification_certificate/certificate_expired',
      name: 'page_0040_notification_certificate2',
      component: page_0040_notification_certificate ,
      meta: {
        requiresAuth: true,
        mode:"certificate_expired_license"
      }
    },
    {
      path: '/notification_certificate/surplus_3_months',
      name: 'page_0040_notification_certificate3',
      component: page_0040_notification_certificate ,
      meta: {
        requiresAuth: true,
        mode:"surplus_license_that_expires_in_3_months"
      }
    },
    {
      path: '/notification_certificate/surplus_expired',
      name: 'page_0040_notification_certificate4',
      component: page_0040_notification_certificate ,
      meta: {
        requiresAuth: true,
        mode:"surplus_expired_license"
      }
    },
    // {
    //   path: '/notification_certificate_over',
    //   name: 'page_0040_notification_certificate_over',
    //   component: page_0040_notification_certificate_over ,
    //   meta: {
    //     requiresAuth: true
    //   }
    // },

    // {
    //   path: '/PageTemp',
    //   name: 'PageTemp',
    //   component: PageTemp,
    //   meta: {
    //     requiresAuth: false
    //   }
    // },
    {
      path: '/expired',
      name: 'Expired',
      component: login,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/menu',
      name: 'menu',
      component: menu,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/menu_master',
      name: 'menu_master',
      component: menu_master,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/menu_maintenance',
      name: 'menu_maintenance',
      component: menu_maintenance,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/menu_configuration',
      name: 'menu_configuration',
      component: menu_configuration,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/menu_certificate',
      name: 'menu_certificate',
      component: menu_certificate,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/menu_inventory',
      name: 'menu_inventory',
      component: menu_inventory,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/master_change_password',
      name: 'page_0041_master_change_password',
      component: page_0041_master_change_password,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/master_user/:seq_id',
      name: 'page_0041_master_user_detail',
      component: page_0041_master_user_detail,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/master_user',
      name: 'page_0041_master_user',
      component: page_0041_master_user,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/master_user/bulk_edit/:p_id',
      name: 'page_0041_master_user_detail_bulk_edit',
      component: page_0041_master_user_detail_bulk_edit,
      meta: {
        load_by:"seq_id",
        requiresAuth: true
      }
    },
    {
      path: '/master_user/approval/:approval_id/:fk_id',
      name: 'page_0041_master_user_detail_bulk_detail_fk_bk',
      component: page_0041_master_user_detail ,
      meta: {
        load_by:"fk_id",
        requiresAuth: true
      }
    },
    {
      path: '/master_belongs/:seq_id',
      name: 'page_0041_master_belongs_detail',
      component: page_0041_master_belongs_detail,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/master_belongs',
      name: 'page_0041_master_belongs',
      component: page_0041_master_belongs,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/master_belongs/clone/:seq_id',
      name: 'page_0010_master_belongs_detail_clone',
      component: page_0041_master_belongs_detail,
      meta: {
        load_by:"clone",
        requiresAuth: true
      }
    },

    {
      path: '/master_software_category/:seq_id',
      name: 'page_0041_master_software_category_detail',
      component: page_0041_master_software_category_detail,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/master_software_category',
      name: 'page_0041_master_software_category',
      component: page_0041_master_software_category,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/master_company/:seq_id',
      name: 'page_0041_master_company_detail',
      component: page_0041_master_company_detail,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/master_company',
      name: 'page_0041_master_company',
      component: page_0041_master_company,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/master_software/:seq_id',
      name: 'page_0041_master_software_detail',
      component: page_0041_master_software_detail,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/master_software',
      name: 'page_0041_master_software',
      component: page_0041_master_software,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/master_system/:seq_id',
      name: 'page_0041_master_system_detail',
      component: page_0041_master_system_detail,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/master_system',
      name: 'page_0041_master_system',
      component: page_0041_master_system,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/master_maker/:seq_id',
      name: 'page_0041_master_maker_detail',
      component: page_0041_master_maker_detail,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/master_maker',
      name: 'page_0041_master_maker',
      component: page_0041_master_maker,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/inventory_reporting_period_detail/:seq_id',
      name: 'page_0041_master_inventory_reporting_period_detail',
      component: page_0041_master_inventory_reporting_period_detail,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/inventory_reporting_period',
      name: 'page_0041_master_inventory_reporting_period',
      component: page_0041_master_inventory_reporting_period,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/master_comprehensive_contract/:seq_id',
      name: 'page_0041_master_comprehensive_contract_detail',
      component: page_0041_master_comprehensive_contract_detail,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/master_comprehensive_contract',
      name: 'page_0041_master_comprehensive_contract',
      component: page_0041_master_comprehensive_contract,
      meta: {
        requiresAuth: true
      }
    },
  {
    path: '/approval_history',
    name: 'page_0050_approval_history_tabs',
    component: page_0050_approval_history_tabs,
    meta: {
      requiresAuth: true,
      tab:"approval_history",
      tab_index:0,
      mode:"normal"
    }
  },
  {
    path: '/approval_history/toroku_filter/:bulk_toroku_number',
    name: 'page_0050_approval_history_tabs_toroku_filter',
    component: page_0050_approval_history_tabs,
    meta: {
      requiresAuth: true,
      tab:"approval_history",
      tab_index:0,
      mode:"toroku_filter"
    }
  },
  {
    path: '/approval_history/all',
    name: 'page_0050_approval_history_tabs_all',
    component: page_0050_approval_history_tabs,
    meta: {
      requiresAuth: true,
      tab:"approval_history_all",
      tab_index:1,
      mode:"normal"
    }
  },
  {
    path: '/approval_history/rejected',
    name: 'page_0050_approval_history_tabs_rejected',
    component: page_0050_approval_history_tabs,
    meta: {
      requiresAuth: true,
      tab:"approval_history",
      tab_index:0,
      mode:"rejected"
    }
  },
  {
    path: '/approval_history/all/rejected',
    name: 'page_0050_approval_history_tabs_all_rejected',
    component: page_0050_approval_history_tabs,
    meta: {
      requiresAuth: true,
      tab:"approval_history_all",
      tab_index:1,
      mode:"rejected"
    }
  },
  {
    path: '/approval_history/detail/:session_id/:validate',
    name: 'page_0050_approval_history_tabs_detail',
    component: page_0050_approval_history_detail,
    meta: {
      requiresAuth: true,
      tab:"approval_history_all",
      tab_index:1
    }
  },
  {
    path: '/id_approval_history',
    name: 'page_0050_id_approval_history',
    component: page_0050_id_approval_history,
    meta: {
      requiresAuth: true
    }
  },
  //{
  //  path: '/pw_approval_history/pending',
  //  name: 'page_0052_pw_approval_history_pending',
  //  component: page_0052_pw_approval_history,
  //  meta: {
  //    mode:"pending",
  //    requiresAuth: true
  //  }
  //},
  //{
  //  path: '/pw_approval_history/:seq_id',
  //  name: 'page_0052_pw_approval_history_detail',
  //  component: page_0052_pw_approval_history_detail,
  //  meta: {
  //    requiresAuth: true
  //  }
  //},
  //{
  //  path: '/pw_approval_history',
  //  name: 'page_0052_pw_approval_history',
  //  component: page_0052_pw_approval_history,
  //  meta: {
  //    requiresAuth: true
  //  }
  //},

  {
    path: '/approval_history_device_embedded_information_detail/:seq_id',
    name: 'page_0051_approval_history_device_embedded_information_detail',
    component: page_0051_approval_history_device_embedded_information_detail,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/notice/:seq_id',
    name: 'page_0090_notice_detail',
    component: page_0090_notice_detail,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/notice',
    name: 'page_0090_notice',
    component: page_0090_notice,
    meta: {
      requiresAuth: true,
      tab_index:0,
    }
  },
  {
    path: '/system_setting',
    name: 'page_0080_system_setting',
    component: page_0080_system_setting_detail,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/browser_setting',
    name: 'page_0080_browser_setting',
    component: page_0080_browser_setting_detail,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/mail_message/:seq_id',
    name: 'page_0081_mail_message_detail',
    component: page_0081_mail_message_detail,
    meta: {
      requiresAuth: true,
    }
  },
  {
    path: '/mail_message_create/:seq_id',
    name: 'page_0081_mail_message_create',
    component: page_0081_mail_message_create,
    meta: {
      requiresAuth: true,
    }
  },
  {
    path: '/mail_message_users/:seq_id',
    name: 'page_0081_mail_message_users',
    component: page_0081_mail_message_users,
    meta: {
      requiresAuth: true,
    }
  },
  {
    path: '/mail_message',
    name: 'page_0081_mail_message',
    component: page_0081_mail_message,
    meta: {
      requiresAuth: true,
    }
  },
  {
    path: '/notice_history',
    name: 'page_0090_notice_history',
    component: page_0090_notice,
    meta: {
      requiresAuth: true,
      tab_index:1,
    }
  },
  {
    path: '/programs_and_permissions/:seq_id',
    name: 'page_0091_programs_and_permissions_detail',
    component: page_0091_programs_and_permissions_detail,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/programs_and_permissions',
    name: 'page_0091_programs_and_permissions',
    component: page_0091_programs_and_permissions,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/deposit_certificate_output',
    name: 'page_0090_deposit_certificate_output',
    component: page_0090_deposit_certificate_output,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/reload',
    name: 'page_0092_reload',
    component: page_0092_reload,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/old_bulk_import',
    name: 'page_0093_old_bulk_import',
    component: page_0093_old_bulk_import,
    meta: {
      requiresAuth: true
    }
  },

  ]
})

var checkCookies = () => {
  var found = 0;
  var s = document.cookie.split(";")
  s.forEach((c) => {
    var kv = c.trim().split("=")
    if (kv[0] == "session_key" && kv[1].length > 70) {
      found++;
    }
    if (kv[0] == "session_user" && kv[1].length > 0) {
      found++;

    }

  })
  return found == 2
}
var checkPreLoginCookies = () => {
  var found = 0;
  var s = document.cookie.split(";")
  s.forEach((c) => {
    var kv = c.trim().split("=")
    if (kv[0] == "session_pre_login_key" && kv[1].length > 70) {
      found++;
    }
    if (kv[0] == "session_user" && kv[1].length > 0) {
      found++;

    }

  })
  return found == 2
}

router.beforeEach((to, from, next) => {
  if( to.meta.isLogin == true && checkCookies() == true ){
    next({
      path: '/menu',
    })
  }else if( to.meta.isPreLogin == true && checkPreLoginCookies() == true ){
    // Not yet logged, but pre-logged
    next()
  }else if( to.meta.isPreLogin == true && checkCookies() == true ){
    next({
      path: '/menu',
    })
  }else if (to.meta.isResetPassword == true && checkCookies() == true) {
    next({
      path: '/menu',
    })
  }else if (to.meta.requiresAuth == true && checkCookies() == false) {
    next({
      path: '/expired',
    })
  } else {
    console.log("router accessing page",to.name)
    next()
  }

})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js